import axios from "axios";

export interface Dictionary {
    [key: string]: string; // Разрешаем любые строковые ключи
}

const conditionNames: Dictionary = {
    "adult": 'Строго 18+',
    "individualReg": 'Индивидуальная регистрация',
    "ownEquip": 'Личная экипировка',
    "accessToWater": 'Доступ к воде',
    "rentKit": 'Аренда снаряжения'
}

export function translateTags(conditionTags: Array<string>) {

  if (!conditionTags) { return [] }

    const conditions: Array<React.ReactNode> = []

    conditionTags.forEach((element, index) => {
        const name = conditionNames[element]

        if (name === undefined ) {
          conditions.push(<li className="additionalInfo_conditions_li" key={index}>{element}</li>)
        }
        else{
            conditions.push(<li className="additionalInfo_conditions_li" key={index}>{name}</li>)
        }
    });

    return conditions
}

export function roundDownToNearest(number: number, steps: number[] = [5, 10, 50, 100, 200, 300, 400, 500, 700, 1000]): number {
  // Проверяем, если число меньше минимального значения в списке
  if (number < steps[0]) {
    return steps[0];
  }

  // Ищем ближайшее снизу число
  for (let i = steps.length - 1; i >= 0; i--) {
    if (number >= steps[i]) {
      return steps[i];
    }
  }

  // Если число больше максимального значения в списке, возвращаем максимальное значение (вообще, оно вернет значения ещё на этапе того цикла, но нуэна заглушка, чтоб ts не ругался )
  return steps[steps.length - 1];
} 

export function fetchCards() {
  return axios.get("events")
}